<div class="container mt-3">
  <p-confirmpopup></p-confirmpopup>
  <form [formGroup]="commentForm" (ngSubmit)="save()">
    <h5>Neue Notiz</h5>
    <div class="p-fluid grid mt-3">

      <div class="field col-12">
        <p-floatlabel>
          <p-select class="w-100" [options]="commentService.contactTypes" formControlName="contact_type"
            optionLabel="title" inputId="contact_type" [showClear]="true"></p-select>
          <label for="contact_type">Kontaktart</label>
        </p-floatlabel>
      </div>

      <div class="field col-12">
        <p-floatlabel variant="in">
          <textarea class="w-100" pTextarea id="comment" formControlName="comment"></textarea>
          <label for="comment">Notiz</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="w-100 d-flex justify-content-end mb-3">
      <p-button type="submit" icon="pi pi-save" [rounded]="true" label="NOTIZ SPEICHERN"></p-button>
    </div>
  </form>

  <p-table [value]="commentService.comments" [paginator]="commentService.comments.length > 10" [rows]="10"
    [showCurrentPageReport]="true" currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Notizen"
    [loading]="loading">
    <ng-template pTemplate="header">
      <tr>
        <th>Datum</th>
        <th>Kontaktart</th>
        <th>Bemerkung</th>
        <th>Autor</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-comment>
      <tr>
        <td>{{comment.date | date : "dd.MM.yyyy"}}</td>
        <td>{{comment.contact_type?.title}}</td>
        <td>{{comment.comment}}</td>
        <td>{{comment.users_permissions_user?.username}}</td>
        <td>
          <p-button icon="pi pi-times" (click)="delete(comment.id, $event)"
            [rounded]="true" severity="danger" [outlined]="true"></p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Keine Notizen</td>
      </tr>
    </ng-template>
  </p-table>


</div>
